(function () {
  // Confine the cross-document View Transition (opted in by view-transitions.css)
  // to collection -> collection navigations (AAS-4743). Every other navigation is
  // skipped so page-transition.js keeps owning it. The page-transition overlay is
  // not rendered on collection pages (see layout/theme.liquid), so nothing else
  // animates the crossfade here — no reveal fade to race against.
  //
  // Runs entirely on the outgoing page in `pageswap`, using the current URL as the
  // origin and the event's destination URL — no Navigation API on the incoming
  // side, so it works across engines. Unsupported browsers never fire `pageswap`,
  // so this is simply inert there.

  function isCollection(url) {
    try {
      return new URL(url, location.href).pathname.indexOf('/collections/') !== -1;
    } catch (e) {
      return false;
    }
  }

  window.addEventListener('pageswap', function (event) {
    if (!event.viewTransition) return;

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var destination = event.activation && event.activation.entry && event.activation.entry.url;

    if (reduced || !(isCollection(location.href) && isCollection(destination))) {
      event.viewTransition.skipTransition();
    }
  });
})();
